import {
  Box,
  Button,
  Center,
  Checkbox,
  Drawer,
  Flex,
  Image,
  LoadingOverlay,
  ScrollArea,
  SimpleGrid,
  Stack,
  Text,
  useMantineTheme,
  Card,
} from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { User1 } from "../../@types/User";
import "../../App.css";
import "../../assets/css/Simulations.css";
import {
  GetAllChapterSimulationsByFilter,
  GetAllSimulationsAccordingToFilter,
  GetAllSubjectSimulationsByFilter,
  getSimulationById,
  GetSubjectSimulationsByFilter,
  getUserSubjectIds,
} from "../../features/Simulations/getSimulationSlice";
import { RootState } from "../../store/ReduxStore";
import { isPremiumModalOpened } from "../../store/premiumModalSlice";
import { ParentPageEvents } from "../../utilities/Mixpanel/AnalyticEventParentApp";
import { WebAppEvents } from "../../utilities/Mixpanel/AnalyticeEventWebApp";
import { Mixpanel } from "../../utilities/Mixpanel/MixpanelHelper";
import filterImg from "../../assets/filterbutimg.png";
import { SubjectSection } from "./SubjectSection";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination } from "swiper/modules";
import { ChapterSection } from "./ChapterSection";
import { showNotification } from "@mantine/notifications";
import { getRandomElements } from "../../utilities/HelperFunctions";

const MobileFilterMain = React.lazy(() => import("./MobileFilterMain"));

enum SimulationTypeEnum {
  UNITY,
  THREEJS,
  MODELJSON,
  REACTIONJSON,
  MOLECULESTRUCTURE,
}

const categoryMap: { [key: string]: string } = {
  0: "Our top simulations",
  1: "Our top simulations",
  2: "Our top 3D Models",
  3: "Our top 3D Animations",
};

interface SimulationCardInterface {
  _id: string;
  name: string;
  lgNo?: number;
  isthreejs?: boolean;
  data?: any;
  simulationType?: number;
  imageUrl: string | undefined;
  simulationTags: string[];
  setSimualtionId: (val: string) => void;
  setPlaySimulation: (id: string, isthreejs?: boolean) => void;
  paramValue: string | null;
  userSubscriptionType: string;
  isSimulationPremium: boolean;
  setModalSimulation: (
    val: {
      name: string;
      _id: string;
      isSimulationPremium: boolean;
      videoUrl: string;
      isthreejs?: boolean;
    } | null
  ) => void;
  videoUrl: string;
  showInfo: boolean;
  simulation?: SimulationData;
  description?: string;
}
const isPremiumModalOpenedActions = isPremiumModalOpened.actions;

export function SimulationCard(props: SimulationCardInterface) {
  const matches = useMediaQuery("(min-width: 56.25em)");
  const dispatch = useDispatch();

  const [hovered, setHovered] = useState(false);
  const handleMouseEnter = () => {
    setHovered(true);
  };
  const handleMouseLeave = () => {
    setHovered(false);
  };

  const theme = useMantineTheme();
  const isMd = useMediaQuery(`(max-width: ${theme.breakpoints.md}px)`);

  return (
    <>
      <Box
        style={{
          cursor: "pointer",
          padding: matches ? "30px 20px" : "5px 5px",
        }}
        onClick={() => {
          props.setModalSimulation({
            name: props.name,
            _id: props._id,
            isSimulationPremium: props.isSimulationPremium,
            videoUrl: props.videoUrl,
            isthreejs: props.isthreejs,
          });
        }}
      >
        <div className="simulation-card" style={{ position: "relative" }}>
          <img
            src={props.imageUrl}
            alt="Props"
            style={{
              width: "100%",
              cursor: "pointer",
              aspectRatio: 1.8,
            }}
            onClick={(e) => {
              props.setModalSimulation({
                name: props.name,
                _id: props._id,
                isSimulationPremium: props.isSimulationPremium,
                videoUrl: props.videoUrl,
                isthreejs: props.isthreejs,
              });
            }}
            className="simulation-img"
          />

          <Image
            src={require("../../assets/playBtn.png")}
            alt="Play"
            width={isMd ? "35px" : "53px"}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            style={{
              position: "absolute",
              top: isMd ? "20%" : "30%",
              left: isMd ? "40%" : "40%",
            }}
            onClick={(e) => {
              e.stopPropagation();

              if (props.userSubscriptionType === "FREE") {
                if (
                  props.isSimulationPremium === undefined ||
                  props.isSimulationPremium
                ) {
                  Mixpanel.track(
                    WebAppEvents.VIGNAM_APP_PREMIUM_FEATURE_ACCESSED,
                    {
                      feature_name: "premium_simulation_accessed",
                      current_page: "all_simulations_page",
                    }
                  );
                  dispatch(isPremiumModalOpenedActions.setModalValue(true));
                } else {
                  props.setPlaySimulation(props._id);
                  props.setModalSimulation(null);
                }
              } else if (props.userSubscriptionType !== "FREE") {
                if (
                  props.isSimulationPremium === undefined ||
                  props.isSimulationPremium
                ) {
                  props.setPlaySimulation(props._id);
                  props.setModalSimulation(null);
                } else {
                  props.setPlaySimulation(props._id);
                  props.setModalSimulation(null);
                }
              }
            }}
          />

          <div style={{ marginBottom: "10px" }}>
            <div
              style={{
                padding: "0.7rem",
                height: isMd ? "80px" : "75px",
                position: "relative",
                width: "100%",
                wordWrap: "break-word",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <span
                    style={{
                      fontSize: isMd ? "14px" : "16px",
                      fontWeight: "700",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (props.userSubscriptionType === "FREE") {
                        if (
                          props.isSimulationPremium === undefined ||
                          props.isSimulationPremium
                        ) {
                          Mixpanel.track(
                            WebAppEvents.VIGNAM_APP_PREMIUM_FEATURE_ACCESSED,
                            {
                              feature_name: "premium_simulation_accessed",
                              current_page: "all_simulations_page",
                            }
                          );
                          dispatch(
                            isPremiumModalOpenedActions.setModalValue(true)
                          );
                        } else {
                          props.setPlaySimulation(props._id);
                        }
                      } else if (props.userSubscriptionType !== "FREE") {
                        if (
                          props.isSimulationPremium === undefined ||
                          props.isSimulationPremium
                        ) {
                          props.setPlaySimulation(props._id);
                        } else {
                          props.setPlaySimulation(props._id);
                        }
                      }
                    }}
                  >
                    {isMd ? (
                      props.name.length > 15 ? (
                        <>{props.name.slice(0, 13)}...</>
                      ) : (
                        <>{props.name}</>
                      )
                    ) : props.name.length > 30 ? (
                      <>{props.name.slice(0, 30)}...</>
                    ) : (
                      <>{props.name}...</>
                    )}
                  </span>
                </div>
                <Box>
                  <Flex>
                    {props.showInfo === true && (
                      <img
                        alt="Info"
                        src={require(`../../assets/infoBtn.png`)}
                        onClick={() => {
                          props.setModalSimulation({
                            name: props.name,
                            _id: props._id,
                            isSimulationPremium: props.isSimulationPremium,
                            videoUrl: props.videoUrl,
                            isthreejs: props.isthreejs,
                          });
                        }}
                        style={{
                          cursor: "pointer",
                          width: "30px",
                          aspectRatio: 1,
                        }}
                      />
                    )}
                  </Flex>
                </Box>
              </div>

              <Flex gap={6}>
                {(props.simulationType === SimulationTypeEnum.UNITY ||
                  props.simulationType === undefined) && (
                  <Image
                    src={require("../../assets/unityIcon.png")}
                    width={"23px"}
                  />
                )}

                {props.simulationType === SimulationTypeEnum.THREEJS && (
                  <Image
                    src={require("../../assets/threejsIcon.png")}
                    width={"23px"}
                  />
                )}

                {props.simulationType === SimulationTypeEnum.MODELJSON && (
                  <>
                    <Image
                      src={require("../../assets/threejsIcon.png")}
                      width={"23px"}
                    />
                    <Image
                      src={require("../../assets/3DmodelsIcon.png")}
                      width={"23px"}
                    />
                  </>
                )}
                {props.simulationType === SimulationTypeEnum.REACTIONJSON && (
                  <>
                    <Image
                      src={require("../../assets/threejsIcon.png")}
                      width={"23px"}
                    />
                    <Image
                      src={require("../../assets/reactionIcon.png")}
                      width={"23px"}
                    />
                  </>
                )}
              </Flex>
            </div>
          </div>
        </div>
      </Box>
    </>
  );
}

interface SimulationInterface {
  selectSimulationCategory: number;
  searchQuery: string;
  setSearchQuery: (val: string) => void;
  isComplete: boolean;
  setisComplete: (val: boolean) => void;
  paramValue: string | null;
  setModalSimulation: (val: any) => void;
  setVideoLoaded: (val: boolean) => void;
  setPlaySimulation: (
    val: {
      name: string;
      _id: string;
      isthreejs?: boolean;
    } | null
  ) => void;
  setSimualtionId: (val: string) => void;
  setSimulation: (val: SimulationData | null) => void;
  isFilterClicked: boolean;
  setMysimualtionId: (val: string | null) => void;
  userSubjects: UserClassAndSubjects[];
  reachedBottom: { state: boolean };
  setReachedBottom: (val: { state: boolean }) => void;
}

export function Simulations(props: SimulationInterface) {
  const enum SimulationDisplayState {
    SUBJECT_WISE,
    CHAPTER_WISE,
    FULL_LIST,
    CHAPTER_WISE_FULL_LIST,
    FILTERS_APPLIED,
  }

  const [simulationDisplayState, setSimulationDisplayState] =
    useState<SimulationDisplayState>();

  const [labels, setlabels] = useState<Simulationfilters[]>([]);

  const [filteredParameters, setfilteredParameters] =
    useState<FilterParameters>({
      labelids: [],
      type: null,
      subjectIds: [],
      subjects: [],
      chapters: [],
      topics: [],
      grades: [],
      miscellaneous: true,
      subjectWiseSkip: new Map(),
      chapterWiseSkip: new Map(),
      skip: -1,
      noOfSimulationsToFetch: 5,
      searchQuery: "",
    });

  const [subjectWiseSkipMap, setSubjectWiseSkipMap] = useState<
    Map<String, number>
  >(new Map());
  const [chapterWiseSkipMap, setChapterWiseSkipMap] = useState<
    Map<String, number>
  >(new Map());

  const [fetchSimulation, setFetchSimulation] = useState(true);

  // This is the point from where fetching simulation api call should go
  useEffect(() => {

    if (
      simulationDisplayState == SimulationDisplayState.CHAPTER_WISE ||
      simulationDisplayState == SimulationDisplayState.SUBJECT_WISE
    ) {
      setFetchSimulation(true);
    } else if (!fetchSimulation) {
      return;
    }
    setIsLoading(true);
    if (simulationDisplayState == SimulationDisplayState.CHAPTER_WISE) {
      GetAllChapterSimulationsByFilter(filteredParameters)
        .then((x: any) => {
          const internalChaptersSimulationsMap = chapterWiseSimulationMap;
          filteredParameters.chapters?.forEach((singleChapterId) => {
            const desiredChapterWiseSimulations: SimulationData[] =
              internalChaptersSimulationsMap.get(singleChapterId) ?? [];
            //setting  chapter id and simulation array mapping map
            x.forEach((simulationArray: SimulationData[]) => {
              simulationArray.forEach((simulation: SimulationData) => {
                if (
                  (simulation.assignedChapters ?? []).findIndex(
                    (chapterId: string) => {
                      return chapterId == singleChapterId;
                    }
                  ) != -1
                ) {
                  //pushing all the simulations in the array for chapter mapping and addign a if condition for duplicates
                  if (
                    desiredChapterWiseSimulations.findIndex(
                      (innerSimulation: SimulationData) => {
                        return simulation._id == innerSimulation._id;
                      }
                    ) == -1
                  ) {
                    desiredChapterWiseSimulations.push(simulation);
                  }

                  //pushing all the simulations in the array and addign a if condition for duplicates
                  if (
                    desiredChapterWiseSimulations.findIndex(
                      (innerSimulation: SimulationData) => {
                        return simulation._id == innerSimulation._id;
                      }
                    ) == -1
                  ) {
                    desiredChapterWiseSimulations.push(simulation);
                  }
                }
              });
            });
            internalChaptersSimulationsMap.set(
              singleChapterId,
              desiredChapterWiseSimulations
            );
          });

          //setting subject wise map and desired simulations
          setchapterWiseSimulationsMap(internalChaptersSimulationsMap);
          setSubjectFilterSimulations([]);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
          showNotification({
            message: "Error in Fetching Simulations, Please Reload",
          });
        });
    } else if (
      simulationDisplayState == SimulationDisplayState.FILTERS_APPLIED
    ) {
      setchapterWiseSimulationsMap(new Map());
      GetAllSimulationsAccordingToFilter(filteredParameters)
        .then((x: any) => {
          const desiredSimulations = subjectFilterSimulations;
          if (x && x.length == 0) {
            setFetchSimulation(false);
          }
          desiredSimulations.push(...x);
          setSubjectFilterSimulations(desiredSimulations);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
          showNotification({
            message: "Error in Fetching Simulations, Please Reload",
          });
        });
    } else {
      setchapterWiseSimulationsMap(new Map());
      GetAllSubjectSimulationsByFilter(filteredParameters)
        .then((x: any) => {
          const desiredSimulations: SimulationData[] = subjectFilterSimulations;
          const initialSize = desiredSimulations.length;
          const internalSubjectsSimulationsMap = subjectsSimulationsMap;
          filteredParameters.subjectIds.forEach((singleSubjectId) => {
            const desiredSubjectWiseSimulations: SimulationData[] =
              internalSubjectsSimulationsMap.get(singleSubjectId) ?? [];
            //setting  subject id and simulation array mapping map
            x.forEach((simulationArray: SimulationData[]) => {
              simulationArray.forEach((simulation: SimulationData) => {
                if (
                  (simulation.assignedSubjects ?? []).findIndex(
                    (subjectId: string) => {
                      return subjectId == singleSubjectId;
                    }
                  ) != -1
                ) {
                  //pushing all the simulations in the array for subject mapping and addign a if condition for duplicates
                  if (
                    desiredSubjectWiseSimulations.findIndex(
                      (innerSimulation: SimulationData) => {
                        return simulation._id == innerSimulation._id;
                      }
                    ) == -1
                  ) {
                    desiredSubjectWiseSimulations.push(simulation);
                  }

                  //pushing all the simulations in the array and addign a if condition for duplicates
                  if (
                    desiredSimulations.findIndex(
                      (innerSimulation: SimulationData) => {
                        return simulation._id == innerSimulation._id;
                      }
                    ) == -1
                  ) {
                    desiredSimulations.push(simulation);
                  }
                }
              });
            });
            internalSubjectsSimulationsMap.set(
              singleSubjectId,
              desiredSubjectWiseSimulations
            );
          });

          if (
            initialSize == desiredSimulations.length &&
            (simulationDisplayState == SimulationDisplayState.FULL_LIST ||
              simulationDisplayState ==
                SimulationDisplayState.CHAPTER_WISE_FULL_LIST)
          ) {
            setFetchSimulation(false);
          }
          //setting subject wise map and desired simulations
          setSubjectFilterSimulations(desiredSimulations);
          setSubjectsSimulationsMap(internalSubjectsSimulationsMap);
          setTopSimulations(getRandomElements(desiredSimulations, 5));
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
          showNotification({
            message: "Error in Fetching Simulations, Please Reload",
          });
        });
    }
  }, [filteredParameters, simulationDisplayState, fetchSimulation]);

  const user = useSelector<RootState, User1 | null>((state) => {
    return state.currentUser.user;
  });

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramValue = queryParams.get("play");
  const simulationId = queryParams.get("id");
  const [opened, { open, close }] = useDisclosure(false);
  const theme = useMantineTheme();
  const isMd = useMediaQuery(`(max-width: ${theme.breakpoints.md}px)`);
  const [subjectsSimulationsMap, setSubjectsSimulationsMap] = useState<
    Map<string, SimulationData[]>
  >(new Map());

  const [chapterWiseSimulationMap, setchapterWiseSimulationsMap] = useState<
    Map<string, SimulationData[]>
  >(new Map());

  // states i use for store all the ids locally
  const [allSubjectIds, setAllSubjectIds] = useState<
    { id: string; name: string; chapters: string[] }[]
  >([]);
  const [allClassIds, setAllClassIds] = useState<
    { id: string; name: string; subjects: string[] }[]
  >([]);
  const [allChapterIds, setAllChapterIds] = useState<
    { id: string; name: string; topics: string[] }[]
  >([]);
  const [allTopicsIds, setAllTopicsIds] = useState<
    { id: string; name: string }[]
  >([]);

  const [topSimulations, setTopSimulations] = useState<SimulationData[]>([]);
  const [selectedClassId, setSelectedClassId] = useState<string>("");
  const [selectedSubjectId, setSelectedSubjectId] = useState<string>("");
  const [selectedChapterId, setSelectedChapterId] = useState<string>("");
  const [subjectFilterSimulations, setSubjectFilterSimulations] = useState<
    SimulationData[]
  >([]);

  useEffect(() => {
    setfilteredParameters((prev) => ({
      ...prev,
      grades: selectedClassId ? [selectedClassId] : prev.grades,
      subjects: selectedSubjectId ? [selectedSubjectId] : prev.subjects,
      chapters: selectedChapterId ? [selectedChapterId] : prev.chapters,
    }));
  }, [selectedChapterId, selectedSubjectId, selectedClassId]);

  const [hovered, setHovered] = useState(false);

  let mySet = new Set<string>();
  props.userSubjects.map((x) => {
    x.subjects.map((y) => {
      mySet.add(y.subjectId);
    });
  });
  let myArray = Array.from(mySet);

  let cleanedSearchQuery = "";
  useEffect(() => {
    cleanedSearchQuery = props.searchQuery.toLowerCase();
    setFetchSimulation(true);
    if (cleanedSearchQuery) {
      setIsLoading(true);
      setSubjectFilterSimulations([]);
      debouncedGetSubjectWiseSimulations();
    } else {
      cleanedSearchQuery =""
      debouncedGetSubjectWiseSimulations.cancel()
      setSimulationDisplayState(SimulationDisplayState.SUBJECT_WISE);
      setfilteredParameters((prev)=>{
        return {
          ...prev,
          searchQuery:""
        }
      })
    }
  }, [props.searchQuery]);

  useEffect(() => {
    setIsLoading(true);
    fetchUserInitialSimulationsAndSubjects();
  }, []);

  const useDebounce = (func: (...args: any[]) => void, delay: number) => {
    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    const debouncedFunction = (...args: any[]) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        func(...args);
      }, delay);
    };

    // Cancel method to clear the timeout
    debouncedFunction.cancel = () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
        debounceTimeout.current = null;
      }
    };

    return debouncedFunction;
  };

  const debouncedGetSubjectWiseSimulations = useDebounce(() => {
    setSimulationDisplayState(SimulationDisplayState.FULL_LIST);
    setfilteredParameters((prev) => ({
      ...prev,
      searchQuery: cleanedSearchQuery,
      subjects: allSubjectIds.map((subject) => subject.id),
      skip: 0,
    }));
  }, 2000);

  function getSimulationTypesArrayFromSelectSimulationCategory(
    selectSimulationCategory: number
  ): number[] {
    switch (selectSimulationCategory) {
      case 0:
        return [0, 1, 2, 3];
      case 1:
        return [0, 1];
        break;
      case 2:
        return [2];
        break;
      case 3:
        return [3];
      default:
        return [0, 1, 2, 3];
    }
  }

  //this will fetch all the initial data for subject wise simulations

  const fetchUserInitialSimulationsAndSubjects = () => {
    setIsLoading(true);
    getUserSubjectIds()
      .then((x: any) => {
        const classIds: { id: string; name: string; subjects: string[] }[] = [];
        const subjectIds: { id: string; name: string; chapters: string[] }[] =
          [];
        const chapterIds: { id: string; name: string; topics: string[] }[] = [];
        const topicIds: { id: string; name: string }[] = [];
        x.instituteClasses.forEach((iClass: any) => {
          iClass.userSubjects
            .filter((singleUserSubject: any) => {
              return (
                (singleUserSubject.subjectId?.classId?.board ?? "") ==
                "BOD-9dabe90f-5c8f-43eb-8c48-c527b1555793"
              );
            })
            .forEach((uSubj: any) => {
              // Check if subjectId already exists, if not, add it
              if (
                uSubj.subjectId &&
                !subjectIds.some(
                  (subjectId: any) => subjectId.id === uSubj.subjectId._id
                )
              ) {
                subjectIds.push({
                  id: uSubj.subjectId._id,
                  name: `${uSubj.subjectId.classId.name} ${uSubj.subjectId.name}`,
                  chapters: uSubj.subjectId.chapters.map((c: any) => c._id),
                });
              }

              // Check if classId exists before adding
              if (
                uSubj.subjectId?.classId &&
                !classIds.some(
                  (classId: any) => classId.id === uSubj.subjectId.classId._id
                )
              ) {
                classIds.push({
                  id: uSubj.subjectId?.classId._id,
                  name: uSubj.subjectId?.classId.name,
                  subjects: uSubj.subjectId?.classId.subjects,
                });
              }

              // Iterate through chapters
              uSubj.subjectId?.chapters.forEach((chapter: any) => {
                if (
                  chapter &&
                  !chapterIds.some(
                    (chapterId: any) => chapterId.id === chapter._id
                  )
                ) {
                  chapterIds.push({
                    id: chapter._id,
                    name: chapter.name,
                    topics: chapter.topics.map((t: any) => t._id),
                  });
                }

                // Iterate through topics
                chapter.topics.forEach((topic: any) => {
                  if (
                    topic &&
                    !topicIds.some((topicId: any) => topicId.id === topic._id)
                  ) {
                    topicIds.push({
                      id: topic._id,
                      name: topic.name,
                    });
                  }
                });
              });
            });
        });

        // store locally for future use or reference
        setAllClassIds(classIds);
        setAllSubjectIds(subjectIds);
        setAllChapterIds(chapterIds);
        setAllTopicsIds(topicIds);

        subjectIds.forEach((innerSubject) => {
          subjectWiseSkipMap.set(innerSubject.id, 0);
        });
        setSubjectWiseSkipMap(subjectWiseSkipMap);
        setfilteredParameters((prev) => ({
          ...prev,
          subjectIds: subjectIds.map((subject) => {
            return subject.id;
          }),
          subjects: subjectIds.map((subject) => {
            return subject.id;
          }),
          subjectWiseSkip: subjectWiseSkipMap,
          simulationType: props.selectSimulationCategory,
        }));
      })
      .catch((e) => {
        setIsLoading(true);
        console.log(e);
        showNotification({
          message: "Error in Fetching Simulations, Please Reload",
        });
      });
  };

  const [selectedKey, setSelectedKey] = useState<string>(
    categoryMap[Number(props.selectSimulationCategory)]
  );

  useEffect(() => {
    setIsLoading(true);
    if (simulationId)
      getSimulationById({ id: simulationId })
        .then((x: any) => {
          setIsLoading(false);
          props.setModalSimulation({
            _id: x._id,
            name: x.name,
            isSimulationPremium: x.isSimulationPremium,
            videoUrl: x.videoUrl,
            isthreejs: x.isthreejs,
          });
        })
        .catch((e) => {
          console.log(e);
          setIsLoading(false);
        });
  }, [simulationId]);

  useEffect(() => {
    if (!paramValue) {
      props.setPlaySimulation(null);
      props.setSimulation(null);
    }
  }, [paramValue]);


  useEffect(() => {
    if (
      (props.reachedBottom.state &&
        simulationDisplayState ==
          SimulationDisplayState.CHAPTER_WISE_FULL_LIST) ||
      simulationDisplayState == SimulationDisplayState.FULL_LIST ||
      (simulationDisplayState == SimulationDisplayState.FILTERS_APPLIED &&
        !isLoading)
    ) {
      setfilteredParameters((prev) => ({
        ...prev,
        skip: (prev.skip ?? 0) + 11,
      }));
    }
    if (props.reachedBottom.state) {
      props.setReachedBottom({ state: false });
    }
  }, [props.reachedBottom]);

  const onClickCloseFilter = (itemId?: string) => {
    if (itemId) {
      if (
        (filteredParameters.grades?.length ?? 0) +
          (filteredParameters.subjects?.length ?? 0) +
          (filteredParameters.chapters?.length ?? 0) +
          (filteredParameters.topics?.length ?? 0) ==
        1
      ) {
        setSimulationDisplayState(SimulationDisplayState.SUBJECT_WISE);
        setfilteredParameters((prev) => ({
          ...prev,
          subjectIds: allSubjectIds.map((subject) => {
            return subject.id;
          }),
          subjects: allSubjectIds.map((subject) => {
            return subject.id;
          }),
          subjectWiseSkip: subjectWiseSkipMap,
          simulationType: props.selectSimulationCategory,
          noOfSimulationsToFetch: 5,
        }));
        return;
      }

      if (simulationDisplayState == SimulationDisplayState.CHAPTER_WISE) {
        setSimulationDisplayState(SimulationDisplayState.SUBJECT_WISE);
      } else if (
        simulationDisplayState == SimulationDisplayState.CHAPTER_WISE_FULL_LIST
      ) {
        setSimulationDisplayState(SimulationDisplayState.CHAPTER_WISE);
      }

      if (filteredParameters.subjects?.includes(itemId)) {
        if (simulationDisplayState == SimulationDisplayState.CHAPTER_WISE) {
          setfilteredParameters((prev) => {
            return {
              ...prev,
              subjects: allSubjectIds.map((singleSubject) => {
                return singleSubject.id;
              }),
              chapters: [],
            };
          });
        } else {
          setfilteredParameters((prev) => {
            return {
              ...prev,
              subjects: prev.subjects?.filter((innerSubjectId) => {
                return itemId != innerSubjectId;
              }),
            };
          });
        }
      } else if (filteredParameters.grades?.includes(itemId)) {
        setfilteredParameters((prev) => {
          return {
            ...prev,
            grades:
              prev.grades?.filter((innerGradeId) => {
                return itemId == innerGradeId;
              }) ?? [],
          };
        });
      } else if (filteredParameters.chapters?.includes(itemId)) {
        if (
          simulationDisplayState ==
          SimulationDisplayState.CHAPTER_WISE_FULL_LIST
        ) {
          setfilteredParameters((prev) => {
            return {
              ...prev,
              chapters:
                allSubjectIds.find(
                  (x) =>
                    prev.subjects?.findIndex((subjectId: string) => {
                      return x.id == subjectId;
                    }) != -1
                )?.chapters ?? [],
              noOfSimulationsToFetch: 5,
            };
          });
        } else {
          setfilteredParameters((prev) => {
            return {
              ...prev,
              chapters:
                prev.chapters?.filter((innerChapterId) => {
                  return itemId == innerChapterId;
                }) ?? [],
            };
          });
        }
      } else if (filteredParameters.topics?.includes(itemId)) {
        //TODO do this later
      }
    }
  };

  return (
    <Stack h="fix">
      <LoadingOverlay visible={isLoading} />

      {/* Top Simulations UI START */}

      {simulationDisplayState == SimulationDisplayState.SUBJECT_WISE &&
        topSimulations.length > 0 && (
          <Center h={isMd ? "30vh" : "40vh"} mt="12px" p="10px">
            <Swiper
              effect="coverflow"
              grabCursor={true}
              centeredSlides={true}
              initialSlide={1}
              slidesPerView="auto"
              coverflowEffect={{
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true,
              }}
              pagination={{ clickable: true }}
              modules={[EffectCoverflow, Pagination]}
              className="mySwiper"
              style={{
                height: isMd ? "70%" : "100%",
                width: "80%",
              }}
            >
              {topSimulations.map((simulation) => (
                <SwiperSlide
                  key={simulation._id}
                  onClick={() => {
                    props.setMysimualtionId(null);
                    props.setPlaySimulation(simulation);
                    props.setModalSimulation(null);
                    props.setVideoLoaded(false);
                  }}
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                  style={{
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    height: "100%",
                    width: isMd ? "80%" : "60%",
                    position: "relative",
                  }}
                >
                  <Image
                    src={simulation.thumbnailImageUrl}
                    alt={`Simulation ${simulation.name}`}
                    style={{
                      display: "block",
                      width: "100%",
                      height: "100%",
                      overflow: "hidden",
                      backgroundColor: hovered
                        ? "rgba(35, 34, 34, 0.21)"
                        : "white",
                      transition:
                        "box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out",
                    }}
                  />

                  {/* Overlay */}
                  <Box
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(100, 99, 99, 0.21)",
                      opacity: hovered ? 1 : 0,
                      transition: "opacity 0.3s ease-in-out",
                      zIndex: 2,
                      pointerEvents: "none",
                    }}
                  />

                  {/* Text */}
                  <Text
                    style={{
                      position: "absolute",
                      bottom: "10px",
                      left: "5%",
                      right: "5%",
                      textAlign: "center",
                      padding: "10px",
                      borderRadius: "5px",
                      color: "white",
                      opacity: hovered ? 1 : 0,
                      transition: "opacity 0.3s ease-in-out",
                      fontWeight: "bold",
                      fontSize: isMd ? "0.9rem" : "1rem",
                      zIndex: 3,
                    }}
                  >
                    {simulation.name}
                  </Text>

                  <Image
                    src={require("../../assets/playBtn.png")}
                    alt="Play"
                    style={{
                      position: "absolute",
                      top: isMd ? "30%" : "40%",
                      left: isMd ? "35%" : "40%",
                      width: isMd ? "35px" : "50px",
                      zIndex: 3,
                    }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Center>
        )}

      {/* Filter UI START */}
      <ScrollArea w={isMd ? "40vh" : "100vh"}>
        <Flex pl={isMd ? 4 : 35} pt={20} pb={5} pr={10} w={"90%"}>
          {(simulationDisplayState == SimulationDisplayState.SUBJECT_WISE ||
            simulationDisplayState ==
              SimulationDisplayState.FILTERS_APPLIED) && (
            <Button
              onClick={open}
              ml={10}
              p={7}
              variant="outline"
              sx={{ borderColor: "#B3B3B3", padding: 0 }}
            >
              {simulationDisplayState ==
                SimulationDisplayState.FILTERS_APPLIED &&
                ((filteredParameters.grades?.length ?? 0) > 0 ||
                  (filteredParameters.subjects?.length ?? 0) > 0 ||
                  (filteredParameters.chapters?.length ?? 0) > 0 ||
                  (filteredParameters.topics?.length ?? 0) > 0) && (
                  <Button
                    variant="filled"
                    bg={"#4B65F6"}
                    p={7}
                    radius={"xl"}
                    sx={{
                      cursor: "pointer",
                      fontSize: 15,
                      borderRadius: "1rem",
                      "&:hover": {
                        backgroundColor: "#4B65F6",
                      },
                    }}
                  >
                    {(filteredParameters.grades?.length ?? 0) +
                      (filteredParameters.subjects?.length ?? 0) +
                      (filteredParameters.chapters?.length ?? 0) +
                      (filteredParameters.topics?.length ?? 0)}
                  </Button>
                )}
              {(simulationDisplayState !=
                SimulationDisplayState.FILTERS_APPLIED ||
                ((filteredParameters.grades?.length ?? 0) == 0 &&
                  (filteredParameters.subjects?.length ?? 0) == 0 &&
                  (filteredParameters.chapters?.length ?? 0) == 0 &&
                  (filteredParameters.topics?.length ?? 0) == 0)) && (
                <img src={filterImg} style={{ margin: "5px" }} />
              )}
              <Text ml={10} color="#B3B3B3">
                Filters
              </Text>
            </Button>
          )}

          {simulationDisplayState != SimulationDisplayState.SUBJECT_WISE &&
            simulationDisplayState != SimulationDisplayState.FULL_LIST && (
              <>
                {filteredParameters.grades?.map((grade) => (
                  <Button
                    variant="filled"
                    ml={10}
                    onClick={() => onClickCloseFilter(grade)}
                    rightIcon={
                      <Image
                        src={require("../../assets/filterCross.png")}
                        width={"16px"}
                      />
                    }
                    bg={"#4B65F6"}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#4B65F6",
                      },
                    }}
                  >
                    {
                      allClassIds.find((singleClass) => {
                        return singleClass.id == grade;
                      })!!.name
                    }
                  </Button>
                ))}
                {filteredParameters.subjects?.map((subs) => (
                  <Button
                    variant="filled"
                    ml={10}
                    onClick={() => onClickCloseFilter(subs)}
                    rightIcon={
                      <Image
                        src={require("../../assets/filterCross.png")}
                        width={"16px"}
                      />
                    }
                    bg={"#4B65F6"}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#4B65F6",
                      },
                    }}
                  >
                    {
                      allSubjectIds.find((singleSubject) => {
                        return singleSubject.id == subs;
                      })!!.name
                    }
                  </Button>
                ))}
                {(simulationDisplayState ==
                  SimulationDisplayState.CHAPTER_WISE_FULL_LIST ||
                  simulationDisplayState ==
                    SimulationDisplayState.FILTERS_APPLIED) &&
                  filteredParameters.chapters?.map((chapter) => (
                    <Button
                      variant="filled"
                      ml={10}
                      onClick={() => onClickCloseFilter(chapter)}
                      rightIcon={
                        <Image
                          src={require("../../assets/filterCross.png")}
                          width={"16px"}
                        />
                      }
                      bg={"#4B65F6"}
                      sx={{
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#4B65F6",
                        },
                      }}
                    >
                      {
                        allChapterIds.find((singleChapter) => {
                          return singleChapter.id == chapter;
                        })!!.name
                      }
                    </Button>
                  ))}
                {filteredParameters.topics?.map((topic) => (
                  <Button
                    variant="filled"
                    ml={10}
                    onClick={() => onClickCloseFilter(topic)}
                    rightIcon={
                      <Image
                        src={require("../../assets/filterCross.png")}
                        width={"16px"}
                      />
                    }
                    bg={"#4B65F6"}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#4B65F6",
                      },
                    }}
                  >
                    {allTopicsIds
                      .find((singleTopic) => {
                        return singleTopic.id == topic;
                      })!!
                      .name.substring(0, 22)}
                  </Button>
                ))}
              </>
            )}
        </Flex>
      </ScrollArea>

      <Stack w="100%">
        <Flex
          style={{
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 15px",
            marginBottom: "15px",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: 400,
            }}
          >
            {props.searchQuery.trim().length !== 0 && (
              <>Search Results for "{props.searchQuery}"</>
            )}
          </span>
          {
            <Center h={"100%"}>
              <Drawer
                size={isMd ? "100%" : "30%"}
                opened={opened}
                onClose={close}
                withCloseButton={false}
              >
                <MobileFilterMain
                  labels={labels}
                  subjects={allSubjectIds}
                  grades={allClassIds}
                  chapters={allChapterIds}
                  topics={allTopicsIds}
                  onClearFilter={() => {
                    close();
                    setfilteredParameters((prev) => ({
                      ...prev,
                      subjectIds: allSubjectIds.map((subject) => {
                        return subject.id;
                      }),
                      subjects: allSubjectIds.map((subject) => {
                        return subject.id;
                      }),
                      subjectWiseSkip: subjectWiseSkipMap,
                      simulationType: props.selectSimulationCategory,
                      noOfSimulationsToFetch: 5,
                    }));
                    setSimulationDisplayState(
                      SimulationDisplayState.SUBJECT_WISE
                    );
                    setIsLoading(true);
                  }}
                  onSubmit={(filteredParameters: FilterParameters) => {
                    close();
                    setSimulationDisplayState(
                      SimulationDisplayState.FILTERS_APPLIED
                    );
                    setSubjectFilterSimulations([]);
                    setfilteredParameters((prev) => {
                      return {
                        ...prev,
                        subjects: filteredParameters.subjects,
                        grades: filteredParameters.grades,
                        chapters: filteredParameters.chapters,
                        topics: filteredParameters.topics,
                        noOfSimulationsToFetch: 11,
                        skip: 0,
                      };
                    });
                  }}
                  onClose={close}
                  currentFilter={
                    simulationDisplayState ==
                    SimulationDisplayState.FILTERS_APPLIED
                      ? filteredParameters
                      : null
                  }
                />
              </Drawer>
            </Center>
          }
        </Flex>

        {/* Filter UI END */}
        <Center w={"100%"} px={8}>
          {/* Simualtions UI */}
          {simulationDisplayState == SimulationDisplayState.SUBJECT_WISE && (
            <SimpleGrid cols={1}>
              {subjectsSimulationsMap.size > 0
                ? Array.from(subjectsSimulationsMap.entries()).map(
                    ([subjectId, simulations]) => {
                      return simulations.length == 0 ? (
                        <></>
                      ) : (
                        <Stack
                          key={subjectId}
                          w={isMd ? "100%" : "95%"}
                          mt={"1rem"}
                          mx={"auto"}
                        >
                          <SubjectSection
                            name={
                              allSubjectIds.find(
                                (item: any) => item.id === subjectId
                              )?.name || "Simulations"
                            }
                            subjectId={subjectId}
                            className={
                              allClassIds.find((cls: any) =>
                                cls.subjects.includes(subjectId)
                              )?.name || "Our Top "
                            }
                            classId={
                              allClassIds.find((cls: any) =>
                                cls.subjects.includes(subjectId)
                              )?.id || "Our Top"
                            }
                            selectedKey={selectedKey!!}
                            simulationCategory={props.selectSimulationCategory}
                            simulations={simulations}
                            onNextCrouselClick={(subject: string) => {
                              if (subject === selectedKey) {
                                return;
                              }
                              const newSkipValue =
                                (subjectWiseSkipMap.get(subjectId) ?? 0) + 5;
                              subjectWiseSkipMap.set(subjectId, newSkipValue);
                              setfilteredParameters((prev) => ({
                                ...prev,
                                subjects: [subjectId],
                                subjectWiseSkip: subjectWiseSkipMap,
                                simulationType: props.selectSimulationCategory,
                                skip: -1,
                                searchQuery: "",
                              }));
                            }}
                            onClickSubjectFilter={(
                              subject: string,
                              subjectId: string,
                              classId: string
                            ) => {
                              if (subjectId === "Our top simulations") {
                                setfilteredParameters((prev) => ({
                                  ...prev,
                                  subjects: allSubjectIds.map((s) => s.id),
                                  subjectWiseSkip: subjectWiseSkipMap,
                                  simulationType:
                                    props.selectSimulationCategory,
                                  noOfSimulationsToFetch: 11,
                                  skip: 0,
                                  searchQuery: "",
                                }));
                                setSimulationDisplayState(
                                  SimulationDisplayState.FULL_LIST
                                );
                                return;
                              }
                              setSubjectFilterSimulations([]);
                              setSelectedSubjectId(subjectId);
                              setSelectedClassId(classId);
                              setfilteredParameters((prev) => ({
                                ...prev,
                                subjects: [subjectId],
                                chapters:
                                  allSubjectIds.find((x) => x.id === subjectId)
                                    ?.chapters ?? [],
                                subjectWiseSkip: subjectWiseSkipMap,
                                simulationType: props.selectSimulationCategory,
                                skip: -1,
                                searchQuery: "",
                              }));
                              setSimulationDisplayState(
                                SimulationDisplayState.CHAPTER_WISE
                              );
                            }}
                            setShowAuthModal={(val: boolean) => {}}
                            setSimualtionId={(val: string) =>
                              props.setSimualtionId(val)
                            }
                            setPlaySimulation={(x: SimulationData) => {
                              props.setPlaySimulation(x)
                              props.setModalSimulation(null);
                              props.setVideoLoaded(false);
                            }}
                            paramValue={props.paramValue}
                            userSubscriptionType={
                              props.paramValue === "parent"
                                ? "PREMIUM"
                                : user?.subscriptionModelType ?? ""
                            }
                            setModalSimulation={(x) => {
                              props.setSimulation(null);
                              props.setModalSimulation(x);
                            }}
                          />
                        </Stack>
                      );
                    }
                  )
                : subjectFilterSimulations.length === 0 && (
                    <Stack w={"100%"} h={"80%"} align="center" justify="center">
                      <Image
                        src={require("../../assets/emptySimulations.png")}
                        m={"auto"}
                        width={"200px"}
                      />
                    </Stack>
                  )}
            </SimpleGrid>
          )}
          {simulationDisplayState == SimulationDisplayState.CHAPTER_WISE && (
            <SimpleGrid cols={1}>
              {chapterWiseSimulationMap.size > 0
                ? Array.from(chapterWiseSimulationMap.entries()).map(
                    ([chapterId, simulations]) => {
                      return simulations.length == 0 ? (
                        <></>
                      ) : (
                        <Stack
                          key={chapterId}
                          w={isMd ? "100%" : "95%"}
                          mt={"1rem"}
                          mx={"auto"}
                        >
                          <ChapterSection
                            name={
                              allChapterIds.find(
                                (item: any) => item.id === chapterId
                              )?.name || "Simulations"
                            }
                            chapterId={chapterId}
                            selectedKey={selectedKey!!}
                            simulationCategory={props.selectSimulationCategory}
                            simulations={simulations}
                            onNextCrouselClick={(chapter: string) => {
                              if (chapter === selectedKey) {
                                return;
                              }
                              const newSkipValue =
                                (chapterWiseSkipMap.get(chapterId) ?? 0) + 5;
                              chapterWiseSkipMap.set(chapterId, newSkipValue);
                              setfilteredParameters((prev) => ({
                                ...prev,
                                chapters: [chapterId],
                                chapterWiseSkip: chapterWiseSkipMap,
                                simulationType: props.selectSimulationCategory,
                                skip: -1,
                                searchQuery: "",
                              }));
                            }}
                            onClickChapterFilter={(
                              chapter: string,
                              chapterId: string
                            ) => {
                              setSimulationDisplayState(
                                SimulationDisplayState.CHAPTER_WISE_FULL_LIST
                              );
                              setfilteredParameters((prev) => ({
                                ...prev,
                                chapters: [chapterId],
                                chapterWiseSkip: chapterWiseSkipMap,
                                simulationType: props.selectSimulationCategory,
                                noOfSimulationsToFetch: 11,
                                skip: 0,
                                searchQuery: "",
                              }));
                            }}
                            setShowAuthModal={(val: boolean) => {}}
                            setSimualtionId={(val: string) =>
                              props.setSimualtionId(val)
                            }
                            setPlaySimulation={(x: SimulationData) => {
                              props.setPlaySimulation(x)
                              props.setModalSimulation(null);
                              props.setVideoLoaded(false);
                            }}
                            paramValue={props.paramValue}
                            userSubscriptionType={
                              props.paramValue === "parent"
                                ? "PREMIUM"
                                : user?.subscriptionModelType ?? ""
                            }
                            setModalSimulation={(x) => {
                              props.setSimulation(null);
                              props.setModalSimulation(x);
                            }}
                          />
                        </Stack>
                      );
                    }
                  )
                : subjectFilterSimulations.length === 0 && (
                    <Stack w={"100%"} h={"80%"} align="center" justify="center">
                      <Image
                        src={require("../../assets/emptySimulations.png")}
                        m={"auto"}
                        width={"200px"}
                      />
                    </Stack>
                  )}
            </SimpleGrid>
          )}

          {(simulationDisplayState == SimulationDisplayState.FULL_LIST ||
            simulationDisplayState ==
              SimulationDisplayState.CHAPTER_WISE_FULL_LIST ||
            simulationDisplayState == SimulationDisplayState.FILTERS_APPLIED) &&
            subjectFilterSimulations.length > 0 && (
              <SimpleGrid cols={isMd ? 2 : 3}>
                {subjectFilterSimulations.length > 0 &&
                  subjectFilterSimulations.map((x, i) => {
                    return (
                      <>
                        <SimulationCard
                          _id={x._id}
                          name={x.name}
                          isthreejs={x.isthreejs}
                          lgNo={4}
                          imageUrl={x.thumbnailImageUrl}
                          simulationType={x.simulationType}
                          setSimualtionId={(val) => props.setSimualtionId(val)}
                          setPlaySimulation={(id) => {
                            props.setPlaySimulation(x)
                            props.setModalSimulation(null);
                            props.setVideoLoaded(false);
                          }}
                          simulationTags={x.simulationTags}
                          paramValue={props.paramValue}
                          userSubscriptionType={
                            props.paramValue === "parent"
                              ? "PREMIUM"
                              : user?.subscriptionModelType ?? ""
                          }
                          isSimulationPremium={x.isSimulationPremium}
                          setModalSimulation={(x) => {
                            props.setSimulation(null);
                            props.setModalSimulation(x);
                          }}
                          videoUrl={x.videoUrl}
                          showInfo={true}
                          simulation={x}
                        />
                      </>
                    );
                  })}
              </SimpleGrid>
            )}
        </Center>
      </Stack>
      {props.searchQuery && subjectFilterSimulations.length === 0 && (
        <Stack w={"100%"} h={"80%"} align="center" justify="center">
          <Image
            src={require("../../assets/emptySimulations.png")}
            m={"auto"}
            width={"200px"}
          />
        </Stack>
      )}
    </Stack>
  );
}
